import { AppointmentsFilterData } from '@sc/data-access-models';

export class AppointmentsFilterAddedAction {
  static readonly type = '[Appointments-filter] Added';

  constructor(public appointmentsFilter: AppointmentsFilterData) {}
}

export class AppointmentsFilterClearedAction {
  static readonly type = '[Appointments-filter] Cleared';
}
